import React, { useState, useEffect } from 'react';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const AnnualIncomeManagement = () => {
  const [annualIncomes, setAnnualIncomes] = useState([]);
  const [newIncome, setNewIncome] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');


  useEffect(() => {
    fetchAnnualIncomes();
  }, []);

  const fetchAnnualIncomes = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/annual-incomes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAnnualIncomes(response.data);
      setError(''); 
    } catch (error) {
      console.error('Error fetching annual incomes:', error);
      setError('年収データの取得に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  const handleAddIncome = async () => {
    if (!newIncome.trim()) {
      setError('年収範囲を入力してください。');
      return;
    }
    // console.log(newIncome);
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/annual-incomes`, 
        { annualIncomeRange: newIncome },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setAnnualIncomes([...annualIncomes, response.data]);
      setNewIncome('');
      setSuccess('年収範囲を追加しました。');
      setError('');
      
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error adding annual income:', error);
      const errorMessage = error.response?.data?.message || '年収範囲の追加に失敗しました。';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIncome = async (id) => {
    if (!window.confirm('この年収範囲を削除しますか？')) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/annual-incomes/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setAnnualIncomes(annualIncomes.filter(income => income._id !== id));
      setSuccess('年収範囲を削除しました。');
      setError('');
      
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error deleting annual income:', error);
      const errorMessage = error.response?.data?.message || '年収範囲の削除に失敗しました。';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddIncome();
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ 
        color: '#2c3e50', 
        marginBottom: '30px',
        fontSize: '24px',
        borderBottom: '2px solid #3498db',
        paddingBottom: '10px'
      }}>
        年収管理
      </h2>

      {/* Success/Error Messages */}
      {success && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #c3e6cb'
        }}>
          {success}
        </div>
      )}
      
      {error && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #f5c6cb'
        }}>
          {error}
        </div>
      )}

      {/* Add New Annual Income */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '18px'
        }}>
          新しい年収範囲を追加
        </h3>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="text"
            value={newIncome}
            onChange={(e) => setNewIncome(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="例: 300万円〜500万円"
            style={{
              flex: 1,
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '14px'
            }}
          />
          <button
            onClick={handleAddIncome}
            disabled={loading || !newIncome.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: loading || !newIncome.trim() ? 'not-allowed' : 'pointer',
              opacity: loading || !newIncome.trim() ? 0.6 : 1,
              fontSize: '14px'
            }}
          >
            {loading ? '追加中...' : '追加'}
          </button>
        </div>
      </div>

      {/* Annual Incomes List */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '18px',
          padding: '20px 20px 0 20px'
        }}>
          年収範囲一覧
        </h3>
        
        {loading ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px',
            color: '#666'
          }}>
            読み込み中...
          </div>
        ) : annualIncomes.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px',
            color: '#666'
          }}>
            年収範囲が登録されていません。
          </div>
        ) : (
          <div style={{ padding: '0 20px 20px 20px' }}>
            {annualIncomes.map((income, index) => (
              <div
                key={income._id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '15px',
                  borderBottom: index < annualIncomes.length - 1 ? '1px solid #eee' : 'none',
                  backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
                }}
              >
                <div style={{ flex: 1 }}>
                  <span style={{ 
                    fontSize: '16px',
                    color: '#2c3e50',
                    fontWeight: '500'
                  }}>
                    {income.annualIncome}
                  </span>
                  <div style={{ 
                    fontSize: '12px',
                    color: '#666',
                    marginTop: '5px'
                  }}>
                    ID: {income._id}
                  </div>
                </div>
                <button
                  onClick={() => handleDeleteIncome(income._id)}
                  disabled={loading}
                  style={{
                    padding: '8px 15px',
                    backgroundColor: '#e74c3c',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.6 : 1,
                    fontSize: '12px'
                  }}
                >
                  削除
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Statistics */}
      <div style={{
        backgroundColor: '#e8f4fd',
        padding: '15px',
        borderRadius: '8px',
        marginTop: '20px',
        border: '1px solid #bee5eb'
      }}>
        <h4 style={{ 
          color: '#0c5460', 
          marginBottom: '10px',
          fontSize: '16px'
        }}>
          統計情報
        </h4>
        <div style={{ color: '#0c5460', fontSize: '14px' }}>
          登録済み年収範囲: {annualIncomes.length}件
        </div>
      </div>
    </div>
  );
};

export default AnnualIncomeManagement; 